export default __webpack_public_path__ + "static/data-about-screenshot-3-f17c9a06721f00b805d8c0c148417c13.webp";